import { render, staticRenderFns } from "./SubjectTypes.vue?vue&type=template&id=4f5bb992&scoped=true&lang=true&"
import script from "./SubjectTypes.vue?vue&type=script&lang=js&"
export * from "./SubjectTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5bb992",
  null
  
)

export default component.exports